<template>
  <div class="black-list__modal">
    <div class="black-list__modal-close" @click.prevent="$emit('modal-close')">
      <span>&times;</span>
    </div>
    <div class="black-list__modal--false d-flex" v-if="!blockedUser">
      <div class="black-list__modal-title">По данному номеру не<br/> найдено совпадений!</div>
    </div>
    <div class="black-list__modal--true" v-else>
      <div class="black-list__modal-title">Найден!</div>
      <div class="black-list__modal-info d-flex">
        <div class="black-list__modal-left">
            <template v-if="blockedUser.contacts.length">
                <div class="black-list__modal-name" v-for="item in blockedUser.contacts">+{{item.contact}}</div>
            </template>

          <div class="black-list__modal-location" v-if="blockedUser.city" v-text="blockedUser.city"></div>
          <div class="black-list__modal-descr" v-if="blockedUser.description" v-text="blockedUser.description"></div>
        </div>
        <div class="black-list__modal-right d-flex" v-if="blockedUser.images.length">

            <a :href="`/storage${image.path}`" :data-count="blockedUser.images.length > 4 ? `+${blockedUser.images.length - 4}` : blockedUser.images.length" :data-lightbox="'blockedUser-' + blockedUser.id" v-for="image in blockedUser.images"
               class="black-list__modal-image black-list__modal-image--count"
               :style="{backgroundImage: 'url(/storage/'+ image.path +')'}"></a>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ['blockedUser'],
  name: "BlackListModal",
  data(){
    return{

    }
  },

  mounted(){
  }

}
</script>

<style lang="scss">
.black-list__modal-image{
  display: none;
  &:nth-child(1),
  &:nth-child(2),
  &:nth-child(3),
  &:nth-child(4){
    display: block;
  }

  &--count{

    &::before{
      position: absolute;
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
      content: attr(data-count);
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      font-size: 10px;
      background: linear-gradient(90deg, rgba(46, 118, 228, 0.7) 0%, rgba(108, 77, 187, 0.7) 100%);
      color: #FFFFFF;
      opacity: 0;
      transition: opacity .2s ease;
    }

    &:hover{
      &::before{
        opacity: 1;
      }
    }

    &:nth-child(1){
      &::before{
        display: none;
      }
    }
  }

}

</style>


<style lang="scss" scoped>

  .black-list__modal{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    text-align: center;

    padding-top: 26px;

  }

  .black-list__modal-close{
    position: absolute;
    top: 0;
    right: 0;
    color: #ECECEC;
    cursor: pointer;
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-size: 30px;
    text-align: center;
    transition: color .2s ease;
    span{
    }

    &:hover{
      color: #333;
    }
  }

  .black-list__modal--false{
    width: 100%;
    height: 100%;
    justify-content: center;
    background: #fff url("/assets/images/catnot.svg") no-repeat bottom center;
  }

  .black-list__modal--true{
    width: 100%;
    height: 100%;
    justify-content: center;
    background: #fff url("/assets/images/cattrue.svg") no-repeat bottom center;
  }

  .black-list__modal-left{
    padding-right: 15px;
      overflow: hidden;
  }

  .black-list__modal-title{
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 10px;
  }

  .black-list__modal-info{
    text-align: left;
    justify-content: flex-start;
  }
  .black-list__modal-name{
    font-weight: bold;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 5px;
  }

  .black-list__modal-location{
    font-size: 12px;
    line-height: 20px;
    color: #929292;
  }

  .black-list__modal-descr{

    overflow: hidden;
    overflow-y: auto;
    height: 100px;
    font-size: 12px;
    line-height: 20px;
    color: #555555;
  }

  .black-list__modal-right{
    padding-right: 14px;
    min-width: 135px;
    flex-wrap: wrap;
  }

  .black-list__modal-image-block{
    width: 100%;
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }


  .black-list__modal-image{
    position: relative;
    width: 33.33%;
    height: 39px;
    border: 1px solid #fff;

    border-radius: 5px;
    overflow: hidden;



    &:first-child{
      width: 100%;
      height: 120px;
      flex-grow: 1;
      background: #aaa;

    }



  }

  @media screen and (max-width: 500px){

    .black-list__modal{
      padding-top: 15px;
    }

    .black-list__modal-info{
      flex-direction: column-reverse;
    }
    .black-list__modal-image{
      width: 25%;
      height: 60px;
    }
    .black-list__modal-image:first-child{
      width: 25%;
      height: 60px;
    }

    .black-list__modal-left{
        padding-right: 0;
    }

    .black-list__modal-descr{
      -webkit-line-clamp: 2;
    }

    .black-list__modal--true{
      background-size: 70px;
      background-position: bottom right;
    }

    .black-list__modal-right{
      padding-right: 0;
    }

  }

</style>
